import * as angular from "angular";
import { IPlot } from "@interfaces/IPlot";
import { ILocationInformation } from "@app/interfaces/ILocationInformation";

export enum BoundsSource {
    Estimated = 0,
    Google = 1
}

export interface IGeocodedAddressLatLng {
    Latitude: number;
    Longitude: number;
}

export interface IGeocodedAddress {
    BoundsSource: BoundsSource;
    FormattedAddress: string;
    Id: number;
    PlaceId: string;
    PostCode: string;
    UtcUpdated: string;

    CenterPoint: IGeocodedAddressLatLng;
    BoundsPoints: IGeocodedAddressLatLng[];
}

export interface IGeocode {
    BoundsSource: BoundsSource;
    FormattedAddress: string;
    PlaceId: string;
    PostCode: string;
    UpdatedTime: string;
    Area: number;

    CenterPoint: number[];
    Bounds: number[][];
}


export interface IAddressComponent {
    ShortName: string;
    LongName: string;
}

export interface IGeometry {
    location: { lat: number, lng: number };
    location_type: string;
    viewport: IViewPort;
    bounds: IViewPort;
}

export interface IViewPort {
    northeast: { lat: number, lng: number };
    southwest: { lat: number, lng: number };
}

export enum LocationType { }

export interface IGeocodeResult {
    address_components: IAddressComponent[];
    formatted_address: string;
    geometry: IGeometry;
    place_id: string;
    types: number[];
}

export class GeocodeService {

    geocoder: google.maps.Geocoder;

    static $inject = ["$q", "$http"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $http: angular.IHttpService) {
    }
    
    getPointFromAddress(address: string, isCountryCode: boolean = false): angular.IPromise<IGeocodeResult[]> {

        return this
            .$http({
                method: "GET",
                url: "/api/map/geocode",
                params: { address: address, isCountryCode: isCountryCode }
            })
            .then((response: angular.IHttpResponse<IGeocodeResult[]>) => {
                return response.data;
            });
    }

    getAddressFromPoint(latlng: google.maps.LatLng): angular.IPromise<ILocationInformation> {
        return this
            .$http({
                method: "GET",
                url: "/api/map/reversegeocode",
                params: { lat: latlng.lat().toFixed(5), lng: latlng.lng().toFixed(5) }
            })
            .then((response: angular.IHttpResponse<ILocationInformation>) => {
                return response.data;
            });
    }
    
    getLocationInformationFromLatLong(latlng: google.maps.LatLng): Promise<ILocationInformation> {
        return (this.getAddressFromPoint(latlng) as Promise<ILocationInformation>);
    }
    
    getLocationInformationFromPlotId(plotId: number): angular.IPromise<ILocationInformation> {
        return this
            .$http({
                method: "GET",
                url: "/api/map/reversegeocodeplot",
                params: { plotId }
            })
            .then((response: angular.IHttpResponse<ILocationInformation>) => {
                return response.data;
            });
    }
    
    getLocationInformationFromVideo(videoEntryId: number): angular.IPromise<ILocationInformation> {
        return this
            .$http({
                method: "GET",
                url: `/api/map/reversegeocode/video/${videoEntryId}`,
            })
            .then((response: angular.IHttpResponse<ILocationInformation>) => {
                return response.data;
            });
    }
    
}
